import setup from "./setup"

const getIsSDKTrackings = () =>
  JSON.parse(localStorage.getItem("@mobi/analytics"))?.isSDKTrackings

const track = (payload) => {
  const isSDKTrackings = getIsSDKTrackings()
  return setup({ isSDKTrackings }).then((_) => {
    if (isSDKTrackings) {
      window.TrackAnalytics.Track({ analytics: payload })
    } else {
      window.analyticsData = payload
      window._frameworkDA.Track()
    }
    console.log("%c @analytics/ga - track", "color: red", payload)
  })
}

const page = (payload) => {
  const isSDKTrackings = getIsSDKTrackings()
  return setup({ isSDKTrackings }).then((_) => {
    if (isSDKTrackings) {
      window.TrackAnalytics.Track({ analytics: payload })
    } else {
      window.analyticsData = payload
      window._frameworkDA.Track()
    }
    console.log("%c @analytics/ga - page view", "color: red", payload)
  })
}

// window.ItauDigitalAnalytics.METHOD -> according doc: https://github-pages-dev.cloud.itau.com.br/itau-oq6-doc-sdkanalytics/documentacao/comece-por-aqui/primeiros-passos-web/config-web/

const defaultParameters = (payload) => {
  const isSDKTrackings = getIsSDKTrackings()
  return setup({ isSDKTrackings }).then((_) => {
    if (isSDKTrackings) {
      window.ItauDigitalAnalytics.setDefaultParameters({ analytics: payload })
    } else {
      window.analyticsData = payload
      window._frameworkDA.Track()
    }

    console.log('%c @analytics/ga - default parameters', 'color: blue', payload)
  })
}

const setUserProperties = (payload) => {
  const isSDKTrackings = getIsSDKTrackings()
  return setup({ isSDKTrackings }).then((_) => {
    if (isSDKTrackings) {
      window.ItauDigitalAnalytics.setUserProperties({ analytics: payload })
    } else {
      window.analyticsData = payload
      window._frameworkDA.Track()
    }

    console.log('%c @analytics/ga - set user properties', 'color: green', payload)
  })
}

const trackEvent = (payload) => {
  const isSDKTrackings = getIsSDKTrackings()
  return setup({ isSDKTrackings }).then((_) => {
    if (isSDKTrackings) {
      window.ItauDigitalAnalytics.track({ analytics: payload })
    } else {
      window.analyticsData = payload
      window._frameworkDA.Track()
    }
    console.log("%c @analytics/ga - trackEvent", "color: red", payload)
  })
}

export default {
  page,
  track,
  trackEvent,
  defaultParameters,
  setUserProperties
}
